/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import React from 'react';
import smoothscrollPolyfill from 'smoothscroll-polyfill';

// intl polyfill for ie11
import 'date-time-format-timezone/build/browserified/date-time-format-timezone-no-data-min.js';
import 'date-time-format-timezone/build/browserified/data/locales/locale-de';
import 'date-time-format-timezone/build/browserified/data/timezones/tzdata-europe-berlin';

import './src/style/global.scss';

import Layout from './src/components/layout';

smoothscrollPolyfill.polyfill();

export function wrapPageElement({element, props}) {
	return (
		<Layout {...props}>
			{element}
		</Layout>
	);
}
